module.exports = __webpack_public_path__ + "static/media/libras_botao.94a49ffa.webp";